<template>
  <section>
    <div class="max-w-screen-2xl mx-auto px-4 flex flex-wrap py-12 my-6">
      <div class="w-full pt-10">
        <h2 class="font-secondary text-2xl md:text-3xl mb-8">
          {{ tr('Itinerary') }}
        </h2>
        <div class="w-full pt-4">
          <div v-for="(d, index) of dayList" :key="`${d?.dateString || d?.dayNr || index}-${replaceNotesKey}`">
            <Day :day="d" v-if="d.services.length == 1"></Day>
            <DayServices :day="d" v-else></DayServices>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Day from '@/components/itinerary/Day.vue';
import DayServices from '@/components/itinerary/DayServices.vue';

export default {
  name: 'DayListGroup',
  props: {},
  computed: {
    booking() {
      return this.$store.state.booking;
    },
    languageNotes() {
      return this.$store.state.languageNotes;
    },
    services() {
      return this.$store.getters.serviceStatusList();
    },
    dayList() {
      return this.$store.getters.dayList;
    },
    replaceNotesKey() {
      return this.$store.state.replaceNotes?.length || 0;
    },
  },
  components: {
    Day,
    DayServices,
  },
  methods: {
    tr(key) {
      return this.$root.tr(key);
    },
  }
}
</script>
